var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pitch"},[_c('HeaderSystemicoComponent',{staticClass:"header_nav__active p-0",attrs:{"menuActive":true,"lang":_vm.lang,"country":"usa"}}),_c('PresentationComponent',{attrs:{"title":"Systemico / <b>Pitch</b>","topics":_vm.topics}}),_c('FooterSystemicoComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }